'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024115 from "./presto.types$-Site-Name$$anon$115.js";
import * as $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024116 from "./presto.types$-Site-Name$$anon$116.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteName$() {
  this.cbq = null;
  this.cbr = false;
  this.cbo = null;
  this.cbp = false;
  this.cbu = null;
  this.cbv = false;
  this.cbs = null;
  this.cbt = false;
  this.cbw = null;
  this.cbx = false;
}
export { $c_Lpresto_types$SiteName$ as $c_Lpresto_types$SiteName$ };
$p = $c_Lpresto_types$SiteName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteName$;
/** @constructor */
function $h_Lpresto_types$SiteName$() {
}
export { $h_Lpresto_types$SiteName$ as $h_Lpresto_types$SiteName$ };
$h_Lpresto_types$SiteName$.prototype = $p;
$p.cIi = (function() {
  if ((!this.cbr)) {
    this.cbq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.cbr = true;
  }
  return this.cbq;
});
$p.iN = (function() {
  if ((!this.cbp)) {
    this.cbo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.cbp = true;
  }
  return this.cbo;
});
$p.adF = (function() {
  if ((!this.cbv)) {
    this.cbu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cbv = true;
  }
  return this.cbu;
});
$p.SQ = (function() {
  if ((!this.cbt)) {
    this.cbs = new $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024115.$c_Lpresto_types$SiteName$$anon$115(this);
    this.cbt = true;
  }
  return this.cbs;
});
$p.cJ7 = (function() {
  if ((!this.cbx)) {
    this.cbw = new $j_presto$002etypes$0024$002dSite$002dName$0024$0024anon$0024116.$c_Lpresto_types$SiteName$$anon$116(this);
    this.cbx = true;
  }
  return this.cbw;
});
var $d_Lpresto_types$SiteName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteName$, "presto.types$SiteName$", ({
  a1N: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteName$ as $d_Lpresto_types$SiteName$ };
var $n_Lpresto_types$SiteName$;
function $m_Lpresto_types$SiteName$() {
  if ((!$n_Lpresto_types$SiteName$)) {
    $n_Lpresto_types$SiteName$ = new $c_Lpresto_types$SiteName$();
  }
  return $n_Lpresto_types$SiteName$;
}
export { $m_Lpresto_types$SiteName$ as $m_Lpresto_types$SiteName$ };
//# sourceMappingURL=presto.types$-Site-Name$.js.map
